import React from 'react';
import { css, cx } from 'styled-system/css';

import { BlurIn } from '@shaojiang/components/motion';
import ShaojiangLink from '@shaojiang/components/ShaojiangLink';
import { page, wrap } from '@shaojiang/components/site/layout';
import { Portrait } from '@shaojiang/components/site/Portrait';
import { Button } from '@shaojiang/components/ui/button';

export default function Error() {
  return (
    <main className={cx(wrap, page, css({ alignItems: 'center', textAlign: 'center' }))}>
      <Portrait pose='necklace' tone='blush' className={css({ w: '56' })} />
      <BlurIn className={css({ textStyle: 'h1' })}>Something went wrong</BlurIn>
      <p
        className={css({ textStyle: 'lead', color: 'fg.muted' })}
      >{`It's not your fault, it's ours. We are working on it.`}</p>
      <Button size='lg' asChild>
        <ShaojiangLink href='/'>Go Home</ShaojiangLink>
      </Button>
    </main>
  );
}
